import React from 'react';

const ProcessForm: React.FC = () => {
  return (
    <div>
      <h2 className="text-xl font-bold mb-4">Nuevo Proceso de Selección</h2>
      <form className="space-y-4">
        <div className="grid grid-cols-2 gap-4">
          <div>
            <label className="block text-gray-700">Nombre</label>
            <input type="text" className="w-full border border-gray-300 p-2 rounded-md" />
          </div>
          <div>
            <label className="block text-gray-700">Empresa *</label>
            <input type="text" className="w-full border border-gray-300 p-2 rounded-md" required />
          </div>
          <div>
            <label className="block text-gray-700">Sub-área *</label>
            <input type="text" className="w-full border border-gray-300 p-2 rounded-md" required />
          </div>
          <div>
            <label className="block text-gray-700">Jornada</label>
            <select className="w-full border border-gray-300 p-2 rounded-md">
              <option>Completa</option>
              {/* Añadir más opciones según sea necesario */}
            </select>
          </div>
          <div>
            <label className="block text-gray-700">Sueldo Mínimo</label>
            <input type="number" className="w-full border border-gray-300 p-2 rounded-md" />
          </div>
          <div>
            <label className="block text-gray-700">Sueldo Máximo</label>
            <input type="number" className="w-full border border-gray-300 p-2 rounded-md" />
          </div>
          <div>
            <label className="block text-gray-700">Cargo *</label>
            <select className="w-full border border-gray-300 p-2 rounded-md" required>
              <option>Seleccionar...</option>
              {/* Añadir más opciones según sea necesario */}
            </select>
          </div>
          <div>
            <label className="block text-gray-700">Horas Semanales</label>
            <input type="number" className="w-full border border-gray-300 p-2 rounded-md" defaultValue={45} />
          </div>
          <div>
            <label className="block text-gray-700">Vacantes *</label>
            <input type="number" className="w-full border border-gray-300 p-2 rounded-md" defaultValue={1} required />
          </div>
          <div>
            <label className="block text-gray-700">Búsqueda *</label>
            <select className="w-full border border-gray-300 p-2 rounded-md" required>
              <option>Interna/Externa</option>
              {/* Añadir más opciones según sea necesario */}
            </select>
          </div>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="especificarMotivo" className="mr-2" />
          <label htmlFor="especificarMotivo" className="text-gray-700">Especificar Motivo</label>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="usarNombreURL" className="mr-2" />
          <label htmlFor="usarNombreURL" className="text-gray-700">Usar nombre en URL Pública y Portal de postulación</label>
        </div>
        <div className="flex items-center">
          <input type="checkbox" id="activarAnalisis" className="mr-2" defaultChecked />
          <label htmlFor="activarAnalisis" className="text-gray-700">Activar análisis curricular con Buk Copilot</label>
        </div>
        <button type="submit" className="bg-blue-500 text-white px-4 py-2 rounded-md mt-4">Crear Proceso</button>
      </form>
    </div>
  );
};

export default ProcessForm;
